import { observer } from "mobx-react-lite";
import React, { useContext } from "react";

import { ApiContext,UserContext } from "../contexts";
import MoreDetailsBtn from "./MoreDetailsBtn";

const YourNewHomeFooter = observer(
  (props: { isShareOrMyDomaineMode: boolean; isHouseLand: boolean }) => {
    const apiContext = useContext(ApiContext);
    const userContext = useContext(UserContext);
    const showFurtherCustomise =
      !props.isHouseLand &&
      apiContext.finalDetailsSettings.further_customise_enabled;

    return (
      <div className={"pyht-your-new-home-footer"}>
        {!props.isShareOrMyDomaineMode && (
          <>
            {apiContext.finalDetailsPriceDisclaimers.map((item) => {
              return (
                <>
                  <div className={"container section-price-disclaimer"}>
                    <div className="copy" dangerouslySetInnerHTML={{__html: item}} />
                  </div>
                </>
              );
            })}

            {apiContext.finalDetailsSettings.finance_cta_title && (
              <div className={"container section-finance-cta"}>
                <div className="inner">
                  <h2 className="finance-title">{apiContext.finalDetailsSettings.finance_cta_title}</h2>
                  {apiContext.finalDetailsFinanceCtaButton && apiContext.finalDetailsFinanceCtaButton.text && apiContext.finalDetailsFinanceCtaButton.link && (
                    <a className="btn"
                      href={apiContext.finalDetailsFinanceCtaButton.link} 
                      target={apiContext.finalDetailsFinanceCtaButton.external ? "_blank" : "_self"} rel="noreferrer" 
                    >
                      {apiContext.finalDetailsFinanceCtaButton.text}
                    </a>
                  )}
                </div>
              </div>
            )}

            {apiContext.finalDetailsSettings.thank_you_enabled && !userContext.isKioskMode && (
              <div
                className={"container section-thank-you copy"}
                dangerouslySetInnerHTML={{
                  __html: apiContext.finalDetailsSettings.thank_you_copy,
                }}
              />
            )}

            {userContext.isKioskMode && (
              <div
                className={"container section-thank-you copy"}
                dangerouslySetInnerHTML={{
                  __html: apiContext.finalDetailsSettings.kiosk_footer_copy,
                }}
              />
            )}

            {apiContext.finalDetailsSettings.promo_enabled && (
              <>
                <div className={"container section section-final-promo"}>
                  {apiContext.finalDetailsSettings.promo_link !== "" ? (
                    <a href={apiContext.finalDetailsSettings.promo_link} target="_blank" rel="noreferrer">
                      {apiContext.finalDetailsSettings.promo_desktop_image && (
                        <img
                          className={"desktop"}
                          src={apiContext.finalDetailsSettings.promo_desktop_image}
                          alt={""}
                        />
                      )}
                      {apiContext.finalDetailsSettings.promo_mobile_image && (
                        <img
                          className={"mobile"}
                          src={apiContext.finalDetailsSettings.promo_mobile_image}
                          alt={""}
                        />
                      )}
                    </a>
                  ) : (
                    <>
                      {apiContext.finalDetailsSettings.promo_desktop_image && (
                        <img
                          className={"desktop"}
                          src={apiContext.finalDetailsSettings.promo_desktop_image}
                          alt={""}
                        />
                      )}
                      {apiContext.finalDetailsSettings.promo_mobile_image && (
                        <img
                          className={"mobile"}
                          src={apiContext.finalDetailsSettings.promo_mobile_image}
                          alt={""}
                        />
                      )}
                    </>
                  )}
                </div>
                <div className="pagebreak"></div>
              </>
            )}

            {showFurtherCustomise && (
              <>
                <div
                  className={"container section section-further-customise copy"}
                  dangerouslySetInnerHTML={{
                    __html:
                    apiContext.finalDetailsSettings.further_customise_copy,
                  }}
                />
                <div className="pagebreak"></div>
              </>
            )}
          </>
        )}

        <div
          className={"container section-disclaimer copy"}
          dangerouslySetInnerHTML={{
            __html: apiContext.finalDetailsSettings.disclaimer_copy,
          }}
        />
      </div>
    );
  }
);

export default YourNewHomeFooter;
